import { differenceInDays, format } from 'date-fns';
import ProfileMixin from './profile';

export default {
  mixins: [ProfileMixin],
  data() {
    return {
      card: {},
      subCancellingInProgress: false,
    };
  },
  computed: {
    allowCancellation() {
      return this.subscriptionReceipt?.autoRenew && this.subscriptionReceipt.paymentMethod === 'Stripe';
    },
    allowUpdates() {
      // we don't want to allow ASE users to see update CC button
      return !this.$store.getters['app/isCertApp'];
    },
    hasActiveSubscription() {
      if (this.subscriptionReceipt) {
        const today = new Date();
        const expirationDate = new Date(this.subscriptionReceipt.expiresAt);
        return today < expirationDate;
      }
      return false;
    },
    hasExpiredSubscription() {
      if (this.subscriptionReceipt) {
        const today = new Date();
        const expirationDate = new Date(this.subscriptionReceipt.expiresAt);
        return today > expirationDate;
      }
      return false;
    },
    isInTrial() {
      return !!this.subscriptionReceipt?.isSubscriptionTrial;
    },
    name() {
      if (!this.subscriptionReceipt) {
        return '';
      }
      // This is a temp hack for testing weekly subscriptions. Efforts are being made to consolidate purchase orders
      // to allow multiple durations and price points. Rather than creating another PO for this weekly subscription
      // test, we can mask it here and refactor into a more permanent solution with the new purchase order model.
      if (differenceInDays(this.subscriptionReceipt.expiresAt, this.subscriptionReceipt.startsAt) === 7) {
        return 'Weekly';
      };

      return this.$store.getters['purchaseOrders/all'].find(po => po.id === this.subscriptionReceipt.purchaseOrderId).name;
    },
    showSubscriptionElsewhere() {
      if (!this.willRenew) {
        return false;
      }
      if (this.allowUpdates && this.allowCancellation) {
        return false;
      }
      return true;
    },
    subscriptionReceipt() {
      return this.user.subscriptionReceipt;
    },
    subscriptionStartDate() {
      // not guaranteed to be present
      if (this.subscriptionReceipt?.startsAt) {
        return format(new Date(this.subscriptionReceipt.startsAt), 'h:mm a MMM d yyyy');
      }
    },
    subscriptionEndDate() {
      return this.subscriptionReceipt && format(new Date(this.subscriptionReceipt.expiresAt), 'MM/dd/yyyy');
    },
    subscriptionEndLabel() {
      return this.willRenew ? 'Renewal Date' : 'End Date';
    },
    willRenew() {
      return !!this.subscriptionReceipt?.autoRenew;
    },
  },
  mounted() {
    this.getCards()
      .then(cards => {
        this.card = cards[0];
      }).catch(() => {
        this.$notify({
          group: 'notifications',
          text: 'An error occurred while loading profile information. Please contact support.',
          type: 'error',
        });
      });
  },
  methods: {
    closeModal(name) {
      this.$modal.hide(name);
    },
    endSubscription() {
      this.closeModal('cancel-subscription-modal');
      this.$store.getters['session/ajax'].post('user/cancel', {
        purchaseReceiptId: this.subscriptionReceipt.id,
      }).then(resp => {
        this.$notify({
          group: 'notifications',
          text: 'Subscription cancelled successfully!',
          type: 'success',
        });
        this.$store.commit('user/set', resp.data.user);
      }).catch(e => {
        this.$notify({
          group: 'notifications',
          text: 'An error occurred while cancelling subscription. Please contact support.',
          type: 'error',
        });
      });
    },
    handleAutoRenew() {
      if (this.subscriptionReceipt?.autoRenew) {
        this.$modal.show('cancel-subscription-modal');
      }
    },
    setCards(cards) {
      this.card = cards[0];
    },
    subscriptionInactiveAction() {
      this.$store.dispatch('ui/toggleUpsellModal', { show: true, source: { type: 'Profile Screen' }});
    },
    updateCreditCard() {
      this.$analytics.events.updatedCreditCard();
      this.$modal.show('subscription-info-modal');
    },
  },
};
